import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3a0207de&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3a0207de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0207de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0207de')) {
      api.createRecord('3a0207de', component.options)
    } else {
      api.reload('3a0207de', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3a0207de&scoped=true&", function () {
      api.rerender('3a0207de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MNuX5tdLd1tY/JS/teamMember.vue"
export default component.exports